import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import ThemeConfig from './theme';
import ScrollToTop from "./Components/ScrollbarTop";
import GlobalStyles from "./theme/globalStyles";
import Router from './Router';
import useAnalytics from './utils/useAnalytics';
import useSourceTracker from './utils/useTrackSource';
import { AuthProvider } from './Components/Context/AuthContext';


function App() {
  useAnalytics();
  useSourceTracker();
  return (
    <HelmetProvider>
      <ThemeConfig>
        <AuthProvider>
          <ScrollToTop />
          <GlobalStyles />
          <Router />
        </AuthProvider>
      </ThemeConfig>
    </HelmetProvider>
  );
}

export default App;
